import axios from 'axios'
export default {
    state: {
        currentPeriods: [],
        closedPeriods: [],
        periods: [],
        openPeriodsToEnd: []
    },
    mutations: {
        getCurrentPeriods(state, periods) {
            state.currentPeriods = periods
        }
        ,
        getClosedPeriods(state, periods) {
            state.closedPeriods = periods
        },

        sortPeriods(state) {
            state.periods = state.currentPeriods.concat(state.closedPeriods)
            state.periods.sort(function compare(a, b) {
                if (a.itemValue < b.itemValue) {
                    return 1;
                }
                if (a.itemValue > b.itemValue) {
                    return -1;
                }
                return 0;
            });
        },


        getEndingPeriodReminder(state, periods) {
            state.openPeriodsToEnd = periods
        }


    },
    actions: {
        async getCurrentPeriods({ commit }) {
            try {
                const result = await axios.get(
                    `${process.env.VUE_APP_BASE_URL}/optionsList/submissionPeriod/en/true`
                );

                result.data = result.data.map(el => ({ ...el, status: true }))
                commit('getCurrentPeriods', result.data)
            }
            catch (e) {
                throw e;
            }

        },

        async getClosedPeriods({ commit }) {
            try {
                const result = await axios.get(
                    `${process.env.VUE_APP_BASE_URL}/optionsList/submissionPeriod/en/false`);

                result.data = result.data.map(el => ({ ...el, status: false }))
                commit('getClosedPeriods', result.data)
            }
            catch (e) {
                throw e;
            }
        },

        async addPeriod({ commit, dispatch }, payload) {
            try {
                const result = await axios.post(`${process.env.VUE_APP_BASE_URL}/admin/addyearperiods/${payload.year}`,)
                await dispatch('getCurrentPeriods')
                await dispatch('getClosedPeriods')
                commit('sortPeriods')
            }
            catch (e) {
                throw e;
            }
        },

        async changePeriodStatus({ }, payload) {
            try {

                const result = await axios.post(`${process.env.VUE_APP_BASE_URL}/admin/updateReportSubmissionPeriod`, payload,)

            }
            catch (e) {
                throw e;
            }
        },

        async getEndingPeriodReminder({ commit }) {
            try {
                const result = await axios.get(`${process.env.VUE_APP_BASE_URL}/system/openperiodends`)

                const openPeriodsToEnd = result.data.filter(el => {
                    if (el.daysToSubmissionEnd <= 10 && el.daysToSubmissionEnd > 0 && el.isOpenForSubmission == true)
                        return el
                })

                commit('getEndingPeriodReminder', openPeriodsToEnd)
            }
            catch (e) {
                throw e
            }
        }

    }
}